<!-- <h3 matDialogTitle></h3> -->
<mat-dialog-content>
  <p>Would you like to extend your time to edit the document? All changes will be saved and the document will be refreshed.</p>
</mat-dialog-content>
<mat-dialog-actions class="buttons">
  <button mat-button matDialogClose (click)="generateNewJWT()">Yes</button>
  <button mat-button matDialogClose>No</button>
</mat-dialog-actions>
